module.exports = __webpack_public_path__ + "static/media/macbook.178b6c71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/macbook.png
// module id = 89
// module chunks = 0